import axios from "axios";
import { Base_URL } from "../url";

export const saveItemType = async (itemTypeData) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const userId = userDetails?.userId; 
    const response = await axios.post(
      `${Base_URL}/ItemTypeMaster/CreateItemType?UserName=${userId}`,
      {
        code: itemTypeData.code,
        description: itemTypeData.description,
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving item type!";
  }
};
